import { Typography } from '@mui/material';
import { DescriptionContainer, DescriptionText, Header, HeaderContainer, SubHeader } from 'src/components/StepElements';
import { useConfiguration } from 'src/providers/Configuration';

export function ManageHeader({
  subTitle,
  description,
  hideProductName,
}: Readonly<{ subTitle?: string; description?: React.ReactNode; hideProductName?: boolean }>) {
  const { name: productName } = useConfiguration();

  return (
    <DescriptionContainer>
      {hideProductName !== true ? (
        <HeaderContainer>
          <Typography variant="h4">{productName}</Typography>
          <Header />
        </HeaderContainer>
      ) : /* istanbul ignore next */ null}
      {subTitle ? <SubHeader>{subTitle}</SubHeader> : /* istanbul ignore next */ null}
      {description ?? <DescriptionText>{description}</DescriptionText>}
    </DescriptionContainer>
  );
}
